import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";


interface AmendmentTenantByPropertyState {
    data: AmendmentTenantByPropertyResponse;
    loading: boolean;
    error: string | null;
}

interface AmendmentTenantByPropertyResponse {
    message: string;
    result: AmendmentTenantByPropertyDetails[];
}

interface AmendmentTenantByPropertyDetails {
    
    tenantId: string;
    tenantName: string;
    unitNumber: string;
    unitSquareFootage: string;
    standardTenant: string;
    naiCcode: string;
}

const initialState: AmendmentTenantByPropertyState = {
    data: {
        message: "",
        result: []
    },
    loading: false,
    error: null
};

export const getTenantByPropertyData = createAsyncThunk("getTenantByPropertyData", async(payload: string,  { rejectWithValue }) => {
    try {
               var url = `${baseUrl}LeaseMaster/GetActiveLeaseByPropId/${payload}`;
        const response = await getApiCall<any>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})

const AmendmentTenatByPropertyDataSlice = createSlice({
    name: 'invData',
    initialState,
    reducers: {
        resetState: (state) => {
            return initialState

        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTenantByPropertyData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getTenantByPropertyData.fulfilled, (state, action: PayloadAction<AmendmentTenantByPropertyResponse>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getTenantByPropertyData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    },
});

export const { resetState: resetAmendmentTenatByPropertyData } = AmendmentTenatByPropertyDataSlice.actions;
export default AmendmentTenatByPropertyDataSlice.reducer;
